"use client";

import { ReactNode } from "react";
import { CustomScroll as Scroll } from "@pikabobalex/react-custom-scroll";

export default function CustomScroll({
  children,
  className,
  heightRelativeToParent,
}: {
  readonly children: ReactNode;
  className?: string;
  heightRelativeToParent?: string;
}) {
  return (
    <Scroll heightRelativeToParent={heightRelativeToParent || "100%"} className={className}>
      {children}
    </Scroll>
  );
}
